import React, { useState } from 'react'

type ZoneDepthTextProps = {
    pitcherPerspective?: boolean
    showMidPlateShadow?: boolean
    showFrontPlateShadow?: boolean
}

export default function ZoneDepthText({
    showMidPlateShadow,
    showFrontPlateShadow,
    pitcherPerspective,
}: ZoneDepthTextProps) {
    const [hovered, setHovered] = useState(false)
    if (!showMidPlateShadow && !showFrontPlateShadow) {
        return null
    }

    // If you change one variable, it's height
    const height = 6 // "rise"
    const slope = 8 / 4
    const run = height / slope
    const width = pitcherPerspective ? 88 : 112
    const startPoint = 500 / 2 - width / 2
    const returnWidth = -width - 2 * run

    const topWidth = pitcherPerspective ? 112 : 90
    const topStartPoint = 500 / 2 - topWidth / 2
    const topReturnWidth = -topWidth - 2 * run

    const midY = pitcherPerspective ? 449 : 426
    const frontY = pitcherPerspective ? 478 : 401

    const plateSize = 20
    const halfPlate = plateSize / 2
    const bandHeight = 3

    let zoneText = ''
    // let homePlateOffSet = 0

    if (showFrontPlateShadow && showMidPlateShadow) {
        zoneText = 'Mix of Front and Middle Zones'
        // homePlateOffSet = -265
    } else if (showFrontPlateShadow) {
        zoneText = 'Zone at Front of Plate'
        // homePlateOffSet = -198
    } else if (showMidPlateShadow) {
        zoneText = 'Zone at Middle of Plate'
        // homePlateOffSet = -208
    }

    const catcherYNudge = halfPlate / 3
    const iconPath = pitcherPerspective
        ? `M${halfPlate},${-catcherYNudge} l${halfPlate},${halfPlate} l0,${halfPlate} l${-plateSize},0 l0,${-halfPlate}`
        : `M0,0 l${plateSize},0 l0,${halfPlate} l-${halfPlate},${halfPlate} l${-halfPlate},${-halfPlate} l0,${-halfPlate}`

    const iconShadowY = pitcherPerspective ? halfPlate + catcherYNudge : 0

    return (
        <>
            {hovered && showMidPlateShadow && (
                <path
                    d={`M${startPoint},${midY} l${width},0 l${run},${height} l${returnWidth},0`}
                    fill="#ccc"
                />
            )}
            {hovered && showFrontPlateShadow && (
                <path
                    d={`M${topStartPoint},${frontY} l${topWidth},0 l${run},${height} l${topReturnWidth},0`}
                    fill="#ccc"
                />
            )}
            <g
                transform="translate(500, 520)"
                onMouseOver={() => setHovered(true)}
                onMouseOut={() => setHovered(false)}
            >
                <g transform={`translate(${10},-15)`}>
                    <path d={iconPath} fill="#ddd" />
                    {showFrontPlateShadow && (
                        <path
                            d={`M0,${iconShadowY} l${plateSize},0 l0,${bandHeight} l${-plateSize},0`}
                            fill="#999"
                        />
                    )}
                    {showMidPlateShadow && (
                        <path
                            d={`M0,${
                                halfPlate - bandHeight / 2
                            } l${plateSize},0 l0,${bandHeight / 2} l${
                                -bandHeight / 2
                            },${bandHeight / 2} l${-plateSize + bandHeight},0`}
                            fill="#999"
                        />
                    )}
                </g>
                <text
                    className="legend"
                    fontSize="18"
                    textAnchor="end"
                    fill="#666"
                >
                    {zoneText}
                </text>
            </g>
        </>
    )
}
